var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCloudUploadIconinline = function SvgCloudUploadIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 52
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cloud-upload-icon_inline_svg__a",
    d: "M43 52V26.258l13.541 13.541 2.829-2.828-18.385-18.385L22.6 36.97l2.828 2.828L39 26.227V52H20C8.954 52 0 43.046 0 32c0-10.578 8.212-19.237 18.608-19.952C20.55 5.098 26.93 0 34.5 0c5.633 0 10.606 2.823 13.584 7.13A13.454 13.454 0 0153.5 6c7.31 0 13.264 5.811 13.493 13.067C75.406 19.82 82 26.89 82 35.5c0 8.945-7.119 16.228-16 16.493V52H43z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#cloud-upload-icon_inline_svg__a",
    fillRule: "evenodd"
  })));
};
export default SvgCloudUploadIconinline;